import React, { useEffect, useState } from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, CartesianGrid, Tooltip } from 'recharts';
import salesService from '../../services/salesService';
import { format, parse } from 'date-fns';

const SalesBarchart = () => {
  const [data, setData] = useState<any[]>([]);
  const [loaded, setLoaded] = useState(false);

  const formatMonthName = (monthStr: string) => {
    const date = parse(monthStr, 'yyyy-MM', new Date());
    return format(date, 'MMMM'); // Full month name
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await salesService.getLast6MonthsSales();
        const formatted = response.map((item: { month: string; sales: number }) => ({
          month: formatMonthName(item.month),
          sales: item.sales,
        }));
        setData(formatted);
        setLoaded(true); 
      } catch (error) {
        console.error('Failed to fetch sales data:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <div style={{ width: '100%', height: 300 }}>
      {loaded && (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            barCategoryGap="30%"
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <Tooltip />
            <Bar
              dataKey="sales"
              fill="#3eb7a9"
              animationBegin={0}
              animationDuration={500}
              animationEasing="ease-out"
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default SalesBarchart;
